import { OPERATIONS_BACKEND_URL } from '@/config'
import { runJsonGet, runJsonPost } from '@/backend-client'
import { transformKeysToCamelCase, transformKeysToSnakeCase } from './utils/casing'
import { transformToDateObj } from './utils/date-time'

export const fetchCompanyDetails = async () => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/ma-franchise/queries/company-details/`
  )
  return transformKeysToCamelCase(data)
}

export const sendTransportRegistrationRequest = async ({
  pickupDate,
  pickupTimeStart,
  pickupTimeEnd,
  deliveryDate,
  deliveryTimeStart,
  deliveryTimeEnd,
  ...rest
}) => {
  const newTransport = {
    pickupStart: transformToDateObj(pickupDate, pickupTimeStart),
    pickupEnd: transformToDateObj(pickupDate, pickupTimeEnd),
    deliveryStart: transformToDateObj(deliveryDate, deliveryTimeStart),
    deliveryEnd: transformToDateObj(deliveryDate, deliveryTimeEnd),
    ...rest
  }
  const { data } = await runJsonPost(`${OPERATIONS_BACKEND_URL}/ma-franchise/commands/`, {
    command: 'register_transport',
    data: transformKeysToSnakeCase(newTransport)
  })
  return transformKeysToCamelCase(data)
}
